/** Shown on edit forms where ITS can be corrected directly (not via Change Requests). */
export const SABIL_ITS_CORRECTION_HELPER =
  "For data-entry correction only. To close or transfer this sabil, use Change Requests.";

export const SABIL_ITS_CLOSED_HELPER = "ITS cannot be changed on a closed sabil.";
